import { userContext } from "src/context/userContext";
import SiteAppBarLoggedInLayout from "./layout/SiteAppBarLoggedInLayout";
import SiteAppBarAnonLayout from "./layout/SiteAppBarAnonLayout";
import { AppBar, Toolbar } from "@mui/material";
import TitleAndLogo from "./components/TitleAndLogo";
import LazyLoader from "../Progress/LazyLoader";
import { lazy, useContext } from "react";
import { isMobile } from "src/components/js/statics1";
const SiteAppBarNotificationsIcon = lazy(() =>
  import("src/components/comms/NotificationsIcon/MyNotificationsIcon")
);

export default function SiteAppBarLayout() {
  const { isLoggedIn } = useContext(userContext) || {};
  return (
    <div className="noPrint" style={{ width: "100%" }}>
      <AppBar
        position="static"
        sx={{
          paddingTop: isMobile() ? 6 : 0,
          // display: "flex",
          // flexDirection: "row",
          // alignItems: "center",
          // justifyContent: "space-between",
        }}>
        <Toolbar style={{ justifyContent: "space-between", minHeight: "46px", paddingBottom: 0 }}>
          {/* Toolbar handles padding and acts as flex container */}
          <TitleAndLogo />
          <div style={{ flex: 1, maxWidth: 800, justifyContent: "flex-end" }}>
            <LazyLoader>
              <SiteAppBarNotificationsIcon />
            </LazyLoader>
            {isLoggedIn ? <SiteAppBarLoggedInLayout /> : <SiteAppBarAnonLayout />}
          </div>
        </Toolbar>
      </AppBar>
    </div>
  );
}
